/**
 * Подпись под кнопкой «Обновить данные» в карточке одного судна.
 *
 * Кнопка спрашивает ОДНО судно, поэтому дробь «4 / 91», принятая у добора по
 * области, здесь не годится — счётчик из одного судна ничего не сообщает.
 * Сообщать обязан ИСХОД, и каждый исход обязан иметь свою фразу.
 *
 * Почему это важно: разбор 08.08.2026 по судну Leda-777 показал, чем кончается
 * молчание интерфейса. Задание закрывалось «готовым», не спросив ни одного
 * источника (браузер висел на голодной машине), полоска исчезала — и человек
 * оставался в уверенности, что позиция свежая, хотя судно молчало пятые сутки.
 *
 * Отдельный исход — «спросили, свежее нет». Это НЕ ошибка: судно может честно
 * молчать в эфире, и у всех трёх источников не быть ничего нового. Смешивать
 * его с неудачей опроса нельзя, иначе исправная работа выглядит поломкой.
 */
import { formatTime, getLang, t } from '../i18n'
import { CARD_UNAVAILABLE_KEY } from '../map/cardRefresh'

export interface VesselRefreshProgress {
  processed: number
  total: number
  updated: number
  done: boolean
  error: string | null
  /** Ждёт в очереди: сколько заданий впереди. null/undefined — уже в работе. */
  queueAhead?: number | null
  /** Поштучный канал ShipFinder закрыт с этого момента (ISO). */
  perShipClosedSince?: string | null
}

export function vesselRefreshLabel(p: VesselRefreshProgress): string {
  // Технический текст наружу не выходит никогда — та же дисциплина, что у
  // добора по области: пользователь не может ничего сделать с RemoteDisconnected.
  if (p.error) return t(CARD_UNAVAILABLE_KEY)
  if (!p.done && p.queueAhead != null && p.queueAhead > 0) {
    return t('models.vessel.refresh.queued', { count: p.queueAhead })
  }
  if (!p.done) return t('models.vessel.refresh.asking')
  // «Свежее нет: судно молчит» при закрытом поштучном канале было бы неправдой:
  // кабинет судно не спрашивали, спрашивали пачку и карточку.
  if (p.updated === 0 && p.perShipClosedSince) {
    return t('models.vessel.refresh.perShipClosed', {
      since: formatTime(getLang(), p.perShipClosedSince),
    })
  }
  if (p.updated > 0) return t('models.vessel.refresh.updated')
  if (p.processed > 0) return t('models.vessel.refresh.silent')
  // Ни один источник не был опрошен: браузер не поднялся, задание прервалось.
  return t('models.vessel.refresh.failed')
}
